export enum TaskMetric {
  TOTAL = 'total_tasks',
  COMPLETED = 'completed_tasks',
  ACTIVE = 'active_tasks',
  ACCEPTED_AS_IS = 'quality_accepted_as_is_percentage',
  ACCEPTED_WITH_EDITS = 'quality_accepted_with_edits_percentage',
  QUALITY_ACCEPTED = 'quality_accepted_tasks',
  QUALITY_REJECTED = 'quality_rejected_percentage',
  AWAITING_REVIEW = 'awaiting_review_tasks',
  NOT_STARTED = 'not_started_tasks',
  AHT = 'aht',
  COMPLETION = 'completion_percentage',
  PENDING_TASK = "pending_tasks",
}

export interface AnalyticsData {
  stage_name: string;
  total_tasks: number;
  completed_tasks: number;
  active_tasks: number;
  pending_tasks: number;
  quality_accepted_as_is_percentage: number;
  quality_accepted_with_edits_percentage: number;
  quality_rejected_percentage: number;
  quality_accepted_as_is_tasks: number;
  quality_accepted_with_edits_tasks: number;
  quality_accepted_tasks: number;
  quality_rejected_tasks: number;
  awaiting_review_tasks: number;
  not_started_tasks: number;
  aht: number;
  completion_percentage: number;
}

export interface MetricConfig {
  key: TaskMetric;
  label: string;
  suffix?: string;
  tooltip?: string;
  valueColor?: string;
}